import type { VueRoute } from "ui-kit/RouterVue";
import addresses from "@/modules/addresses/router";
import auth from "@/modules/auth/router";
import chats from "@/modules/chats/router";
import contacts from "@/modules/contacts/router";
import departments from "@/modules/departments/router";
import users from "@/modules/users/router";
import elections from "@/modules/elections/router";
import events from "@/modules/events/router";
import eventTypes from "@/modules/event-types/router";
import eventProjects from "@/modules/event-projects/router";
import commissions from "@/modules/comissions/router";
import userTasks from "@/modules/cabinet/tasks/router";
import customFields from "@/modules/custom-fields/router";
import { h } from "vue";

const routes: VueRoute[] = [
  addresses,
  auth,
  ...chats,
  contacts,
  ...departments,
  users,
  ...elections,
  ...events,
  eventTypes,
  eventProjects,
  commissions,
  userTasks,
  customFields,
  {
    path: "/",
    action: async () => {
      const c = await import("@/views/default.vue");
      return h(c.default);
    },
  },
];

export default routes;
